import { createContext, useContext, useState } from 'react'

const requestTabsContext = createContext<{
  outerComponent: JSX.Element
  setOuterComponent: React.Dispatch<React.SetStateAction<JSX.Element>>
}>({
  outerComponent: <></>,
  setOuterComponent: () => {}
})
export const useRequestTabsContext = () => useContext(requestTabsContext)

export default function RequestProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [outerComponent, setOuterComponent] = useState(<></>)

  return (
    <requestTabsContext.Provider
      value={{
        outerComponent,
        setOuterComponent
      }}
    >
      {children}
    </requestTabsContext.Provider>
  )
}
